<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-13 10:11:49
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CustomForm\previewCustomForm.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-10-22 14:40:46
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_customForm_form_previewTitle')"
    pad="0"
    delBtn
    widthClass="max-1000"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper
        :curStep="curStep"
        :items="stepper"
        @step="(step) => (curStep = step)"
      >
        <template v-slot:content-1>
          <v-container fluid class="pa-0 ma-0">
            <v-sheet class="text-h4 text--primary my-2">{{
              $getCommonLangValue(customFormData.application_type_name)
            }}</v-sheet>
            <v-sheet class="text-body-2 text--secondary my-2">{{
              $getCommonLangValue(customFormData.application_type_desc)
            }}</v-sheet>
            <v-sheet class="text-body-2 text--primary my-2"
              >*{{ customFormData.remarks }}</v-sheet
            >
          </v-container>
          <!-- terms -->
          <v-container fluid>
            <v-sheet class="text-h4 text--primary my-2">{{
              $t("label_essweb_customForm_form_termsTitleLabel")
            }}</v-sheet>
            <v-container fluid class="pa-0 ma-0">
              <v-sheet
                class="d-flex justify-start py-3"
                v-for="(item, index) in NoticeList"
                :key="`notice--${index}`"
                v-if="
                  $getCommonLangValue(
                    item['application_type_notice_point_' + item.number]
                  ) !== ''
                "
              >
                <div style="width: 20px" class="flex-shrink-1">
                  <svg-icon
                    size="12"
                    :fill="item.color_code"
                    iconClass="LabeledColour"
                  />
                </div>
                <div class="ml-2">
                  {{
                    $getCommonLangValue(
                      item["application_type_notice_point_" + item.number]
                    )
                  }}
                </div>
              </v-sheet>
            </v-container>
          </v-container>
        </template>
        <template v-slot:content-2>
          <v-form ref="form" lazy-validation>
            <v-row>
              <DynamicForm
                :data="item"
                v-for="(item, index) in desserts"
                :key="`formitem--${index}`"
              />
            </v-row>
          </v-form>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions> </template>
    <!-- actions -->
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "previewCustomForm",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      NoticeList: [],
      stepper: [
        "label_essweb_customForm_form_tab_TermsLabel",
        "label_essweb_customForm_form_tab_FormLabel",
      ],
      curStep: 1,
      step: 2,
      customFormData: {
        status: 1,
        application_type_name: "",
        type_code: "",
        application_type_desc: "",
        flow_template_uuid: "",
        color_code: "",
        sequence: 1,
        application_type_notice_point_1: "",
        application_type_notice_point_2: "",
        application_type_notice_point_3: "",
        application_type_notice_point_4: "",
        application_type_notice_point_5: "",
      },
      headers: [
        {
          text: "label_essweb_customForm_form_list_item_sequenceLabel",
          value: "sequence",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_labelLabel",
          value: "label",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_typeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_isMandatoryLabel",
          value: "mandatory",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          sortable: false,
          align: "end",
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getDetail();
    this.getNotice();
    this.getItemsList();
  },
  methods: {
    getItemsList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_custom_field",
        url: "/common-application-type-custom-field/get-list/",
        data: {
          application_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.desserts = res.data;
      });
    },
    getNotice: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_notice",
        url: "/common-application-type-notice/get-list/",
        data: {
          application_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data[1] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[2] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[3] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[4] = JSON.parse(JSON.stringify(res.data[0]));

        res.data[0]["number"] = 1;
        res.data[1]["number"] = 2;
        res.data[2]["number"] = 3;
        res.data[3]["number"] = 4;
        res.data[4]["number"] = 5;
        res.data.map((item, index) => {
          item["application_type_notice_point_" + (index + 1) + "_save"] =
            item["application_type_notice_point_" + (index + 1)];
        });
        that.NoticeList = res.data;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/common-application-type/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        this.customFormData = res.data;
      });
    },
  },
};
</script>